/**
 * Specialties Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
};

// Getters
const getters = {
};

// Actions
const actions = {
    createSpecialtyFollowed(context, payload) {
        function successCallback(response) {
            /*Vue.swal(
                payload.successMessage,
                '',
                'success'
            );*/

            // router.push({ name: 'consultationType', params: { consultationType: response.data.consultationType.slug } });
        }

        function errorCallback(error) {
            /*Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );*/
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateSpecialtyFollowed(context, payload) {
        function successCallback(response) {
            /*Vue.swal(
                payload.successMessage,
                '',
                'success'
            );*/
        }

        function errorCallback(error) {
            /*Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );*/
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
        const url = AppConfig.apiUrl + apiModel.SpecialtyFollowed.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);
    },

    deleteAllSpecialtyFollowed(context, payload) {
        function successCallback(response) {
            /*Vue.swal(
                payload.successMessage,
                '',
                'success'
            );*/
        }

        function errorCallback(error) {
            /*Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );*/
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.SpecialtyFollowed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
        const url = AppConfig.apiUrl + apiModel.SpecialtyFollowed.Create.url + 's/delete';

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },
};

// Mutations
const mutations = {
    getSpecialtiesHandler(state, { specialties }) {
        // Update specialties state
        state.specialties = specialties;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
